import { NavLink } from "react-router-dom";
import { ChartBarIcon, UsersIcon, SalesIcon, CouponIcon, MailIcon, SettingsIcon } from "../../constants/icons";

const AdminSidebar = () => {
    const navItems = [
        { path: "/admin-dashboard", label: "Dashboard", icon: <ChartBarIcon /> },
        { path: "users", label: "Users", icon: <UsersIcon /> },
        { path: "sales", label: "Sales Tracking", icon: <SalesIcon /> },
        { path: "coupons", label: "Coupons", icon: <CouponIcon /> },
        { path: "promotions", label: "Promotions", icon: <MailIcon /> },
        { path: "settings", label: "Settings", icon: <SettingsIcon /> },
    ];

    return (
        <aside className="w-64 bg-white shadow-md min-h-screen flex flex-col sticky top-0">
            <div className="p-6 text-center border-b">
                <h1 className="text-2xl font-bold text-red-700">FlavourFusion</h1>
                <p className="text-xs text-gray-500">Admin Panel</p>
            </div>
            <nav className="flex-1 px-4 py-6 space-y-2">
                {navItems.map(item => (
                    <NavLink
                        key={item.path}
                        to={item.path}
                        end={item.path === "/admin-dashboard"}
                        className={({ isActive }) =>
                            `flex items-center px-4 py-3 rounded-lg transition-all duration-200 ease-in-out ${isActive
                                ? 'bg-red-600 text-white shadow-lg'
                                : 'text-gray-600 hover:bg-red-50 hover:text-red-700'
                            }`
                        }
                    >
                        {item.icon}
                        <span className="ml-4 font-medium">{item.label}</span>
                    </NavLink>
                ))}
            </nav>
            <div className="p-4 border-t">
                <div className="flex items-center">
                    <img src="https://placehold.co/40x40/E53E3E/FFFFFF?text=A" alt="Admin" className="rounded-full" />
                    <div className="ml-3">
                        <p className="font-semibold text-sm text-gray-800">Admin User</p>
                        <p className="text-xs text-gray-500">manager@flavourfusion.co.uk</p>
                    </div>
                </div>
            </div>
        </aside>
    );
};
export default AdminSidebar;